<div class="w-100">
  <div class="dados-bancarios p-3">
    <bdg-label type="subheading-1">
      {{ dsTipoConta }}
    </bdg-label>

    <div>
      <bdg-label>
        <ng-content></ng-content>
      </bdg-label>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <bdg-select-field [control]="form.controls.banco" label="Banco" [provider]="bancosProvider"></bdg-select-field>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-3 mb-2">
        <bdg-input-field
          [control]="form.controls.codigoAgencia"
          label="Código da agência"
          hint="Não incluir o dígito verificador"
          [maxLength]="4"
          (blurEvent)="onCodigoAgenciaBlur()"
          [mask]="'0*'"
        ></bdg-input-field>
      </div>
      <div class="col-xs-12 col-md-7 pt-2">
        <div class="d-flex align-items-end">
          <bdg-label type="subheading-1">Agência</bdg-label>
          <mat-icon *ngIf="showAgenciaNaoEncontrada" class="ml-1" style="color: #bf360c">warning</mat-icon>
        </div>
        <bdg-label type="subheading-2">
          {{ labelAgencia }}
        </bdg-label>
      </div>
      <div class="col-xs-12 col-md-5">
        <bdg-input-field
          [control]="form.controls.numeroConta"
          label="N° da conta"
          [maxLength]="12"
          [mask]="'0*'"
        ></bdg-input-field>
      </div>
      <div class="col-xs-12 col-md-2">
        <bdg-input-field
          #digito
          [control]="form.controls.digitoVerificadorConta"
          label="Dígito"
          [maxLength]="1"
          (input)="form.patchValue({ digitoVerificadorConta: onlyDigitsXP($event.target.value.toUpperCase()) })"
        ></bdg-input-field>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <bdg-checkbox-field
          class="position-relative"
          [label]="'Confirmo que as informações preenchidas estão corretas.'"
          [control]="form.controls.dadosConfirmados"
        ></bdg-checkbox-field>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-md-12 mt-2">
      <app-file-uploader
        [formGroup]="form"
        [title]="getTitle()"
        [control]="form.controls.comprovanteAnexo"
        accept=".pdf,.png,.jpg"
        [maxSize]="10"
      ></app-file-uploader>
    </div>
  </div>
</div>
